import Axios from "axios";
import { SET_SALES_LETTER_INFO_LIST, UNSET_SALES_LETTER_INFO_LIST } from "@/store/mutation-types";

import { saveUpdateSlsLetterInfo, getSlsLetterInfo } from "@/store/api";

// initial state
const state = {
    getSlsLetterInfo: [],
}

const getters = {
    getSlsLetterInfo(state){
        return state.getSlsLetterInfo;
    }
}

const mutations = {
    [SET_SALES_LETTER_INFO_LIST](state, data) {
        state.getSlsLetterInfo = data;
    },
    [UNSET_SALES_LETTER_INFO_LIST](state) {
        state.getSlsLetterInfo = [];
    }
}

const actions = {
    saveUpdateSlsLetterInfo({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateSlsLetterInfo, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSlsLetterInfo({ commit }) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSlsLetterInfo)
                .then(function (response) { 
                    commit(SET_SALES_LETTER_INFO_LIST, response.data.data);
                    resolve(response.data.data);  
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },
}


export default {
    state,
    getters,
    actions,
    mutations,
};